export function first_present(values = []) {
  return values.find((value) => value !== undefined && value !== null && value !== '') || '';
}

export function role_form_values(component, form) {
  const values = {};
  values.role_name = component.normalize_text(form.role_name);
  values.role_description = component.normalize_text(form.role_description);
  values.group_id = component.normalize_text(form.group_id);
  values.new_group_name = component.normalize_text(form.new_group_name);
  values.hourly_rate = component.normalize_hourly_rate(form.hourly_rate);
  return values;
}

export function normalized_role_projects(role = {}) {
  const role_project_ids = Array.isArray(role.project_ids) ? role.project_ids : [];
  const role_projects = Array.isArray(role.projects) ? role.projects : [];
  const normalized_project_ids = role_projects
    .map(normalized_project_id)
    .filter((project_id) => project_id != null && project_id !== '');
  return role_project_ids.length ? role_project_ids : normalized_project_ids;
}

export function role_group_name(role = {}) {
  return first_present([role.group_name, role.group?.name]);
}

export function role_id(role = {}) {
  return first_present([role.id, role.role_id, role.pk]) || null;
}

export function role_name(role = {}) {
  return String(first_present([role.role, role.name, 'Unnamed Role'])).trim();
}

export function project_items(response_data = {}) {
  if (Array.isArray(response_data)) {
    return response_data.map(project_item);
  }
  const items = first_present([response_data.data, response_data.projects, []]);
  return Array.isArray(items) ? items.map(project_item) : [];
}

export function edit_role_form(role = {}) {
  const form = {};
  form.role_id = first_present([role.id]) || null;
  form.role_name = String(first_present([role.name])).trim();
  form.role_description = String(first_present([role.description])).trim();
  form.group_id = edit_group_id(role);
  form.new_group_name = '';
  form.hourly_rate = role.hourly_rate ?? '';
  return form;
}

function normalized_project_id(project) {
  return first_present([project?.id, project?.project_id, project]);
}

function project_name(project = {}) {
  return first_present([project.project_name, project.name, `Project ${project.id || ''}`]);
}

function project_item(project = {}) {
  const item = {};
  item.id = project.id;
  item.name = project_name(project);
  item.description = project.project_description || '';
  return item;
}

function edit_group_id(role = {}) {
  return role.group_id ? String(role.group_id) : '';
}
